export default __webpack_public_path__ + "assets/2bf3dd9e72c6435f400aa7d26ad748c6.svg";